export function validateValue(value) {
  return value == null ? 'N/I' : value
}
